import authService from '@/utils/authService'
import api from '@/utils/api'
import loginService from '@/utils/loginService'

const state = {
  connectedUser: null,
  initialiazed: false
}

const mutations = {
  setConnectedUser (state, user) {
    state.connectedUser = user
  },
  update (state, data) {
    for (let k in data) {
      state.connectedUser[k] = data[k]
    }
  }
}

const actions = {
  setLanguage ({state}, lang) {
    if (state.initialiazed && state.connectedUser) {
      state.connectedUser['lg'] = lang
      api.put('/me', {
        lg: lang
      })
    }
  },
  setConnectedUser ({commit}, user) {
    return commit('setConnectedUser', user)
  },
  logout ({commit}, user) {
    commit('setConnectedUser', null)
    authService.cleanToken()
  },
  tryLogin (store, info) {
    return loginService.tryLogin(info.username, info.password)
  },
  tokenChange ({state, commit, dispatch}) {
    return new Promise((resolve, reject) => {
      if (authService.hasValidToken()) {
        if (!state.connectedUser) {
          api.get('/me', {params: {fullView: true}}).then((response) => {
            dispatch('setConnectedUser', response.data).then(() => {
              resolve()
            })
          }).catch(() => {
            resolve()
          })
          return
        }
      } else {
        if (state.connectedUser) {
          commit('setConnectedUser', null)
        }
      }
      resolve()
    })
  },
  // try to init user from localStorage

  initFromStorage ({state, dispatch}) {
    return new Promise((resolve, reject) => {
      authService.getToken().then(() => {
        dispatch('tokenChange').then(() => {
          resolve()
          state.initialiazed = true
        }).catch(() => {
          reject()
          state.initialiazed = true
        })
      }).catch(() => {
        resolve()
        state.initialiazed = true
      })
    })
  },
  update (ctx, data) {
    return api.put('/me', data).then((response) => {
      ctx.commit('update', response.data)
    })
  }
}

const getters = {
  isConnected (state) {
    return state.connectedUser !== null
  },
  user (state) {
    return state.connectedUser
  },
  isInitialized (state) {
    return state.initialiazed
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/user.js